// extracted by mini-css-extract-plugin
export var categoryIcon = "_ds-5";
export var connectorContainer = "_ds-1";
export var connectorLine = "_ds-0";
export var minHeight0 = "_ds-6";
export var relativeUnitValueSelector = "_ds-2";
export var trifoldSelectorBody = "_ds-4";
export var trifoldSelectorList = "_ds-3";